/** The `combat` save slice (combat.md: ladder, records (spec + inputs ≤ 2 KB each)). F0 stub at v1; the owning feature defines the shape and its migrations (architecture §4.4). */
import type { GrantResult, SliceDef } from '../shared';
import type { DuelBeat, DuelState, OpponentId } from './sim';
import { isSuperAction,isTechniqueAction } from './sim';
import { validateCombatBuild } from './buildValidation';

/** Special actions and a helpless rival preserve the chain; a missed ordinary counter breaks it. */
export function peakCounterCombo(beats: readonly DuelBeat[]): number {
  let current = 0, best = 0;
  for (const beat of beats) {
    if (beat.action === 'prayer' || isSuperAction(beat.action)||beat.rivalPhase === 'stumbled') continue;
    if(isTechniqueAction(beat.action)&&!beat.counter)continue;
    current = beat.counter ? current + 1 : 0;
    best = Math.max(best, current);
  }
  return best;
}

export interface DuelRecord { id: string; opponent: OpponentId; won: boolean; rounds: number; counters: number }
export interface CombatSave {
  v: 1; serial: number; wins: number; losses: number; bestCombo: number;
  active: { id: string; state: DuelState; receipt?: GrantResult['lines'] } | null; history: DuelRecord[];
  [key: string]: unknown;
}
export function readCombat(value: { v: number } & Record<string, unknown>): CombatSave {
  return { serial: 0, wins: 0, losses: 0, bestCombo: 0, active: null, history: [], ...value } as CombatSave;
}

export const combatSlice: SliceDef<CombatSave> = {
  key: 'combat',
  version: 1,
  create: () => ({ v: 1, serial: 0, wins: 0, losses: 0, bestCombo: 0, active: null, history: [] }),
  migrations: {},
  validate: validateCombatBuild,
};
